export default import.meta.ROLLDOWN_FILE_URL_V3Oy2CX9Ii5YsNdQd38_xw